import { CardTitle } from '@internal/ui-common';
import { InfoCard } from '@backstage/core-components';
import { Legend } from '@internal/ui-common';
import { OverspendIndicator } from './overspendIndicator/OverspendIndicator';
import { TeamCostSummary } from '@internal/schemas-common';
import { getCategoryColor } from '../../helpers/colors';
import { useStyles } from './overspendCard.style';

const legendItems = [
  { color: getCategoryColor('red'), label: 'Actions needed' },
  { color: getCategoryColor('green'), label: 'No actions needed' },
  { color: getCategoryColor('nodata'), label: 'No Data' },
];

interface OverspendCardProps
  extends Readonly<Pick<TeamCostSummary, 'overspend' | 'color'>> {
  title: string;
  hasCostData: boolean;
  avatar?: string;
  link?: string;
}

function OverspendCard({
  overspend,
  color,
  title,
  avatar = '',
  link = '',
  hasCostData,
}: OverspendCardProps) {
  const { classes, cx } = useStyles();

  return (
    <InfoCard
      title={
        link.length > 0 ? (
          <CardTitle
            title={title as string}
            picture={avatar as string}
            link={link}
          />
        ) : (
          title
        )
      }
    >
      <div className={cx(classes.overspendCard)}>
        <OverspendIndicator
          overspend={overspend}
          color={color}
          hasCostData={hasCostData}
        />
        <div className={classes.legendContainer}>
          <Legend legendItems={legendItems} />
        </div>
      </div>
    </InfoCard>
  );
}

export { OverspendCard };
